
<div class="stepper-container">

<mat-card>
    <mat-card-header style="justify-content: center;">
      <mat-card-title>Bank Information</mat-card-title>
    </mat-card-header>
    <mat-card-content>

            <form >
                <div class="row">
                  <div class="column">
                    <mat-form-field appearance="outline" >
                      <mat-label>Account Name</mat-label>
                      <input readonly="readonly" matInput placeholder="Account Name"
                             >
                    </mat-form-field>
                  </div>
                  <div class="column">
                    <mat-form-field appearance="outline">
                      <mat-label>Routing Number</mat-label>
                        <input readonly="readonly"  matInput  >
                        <button style="height: 100%;width: 100%;" disabled="disabled" mat-button matSuffix mat-stroked-button aria-label="search">
                   BANK INFO
                      </button>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="column">
                    <mat-form-field appearance="outline" >
                      <mat-label>Account Number</mat-label>
                      <input readonly="readonly"  matInput  placeholder="Account Number"
                             >
                    </mat-form-field>
                  </div>
                  <div class="column">
                    <mat-form-field appearance="outline" >
                      <mat-label>Confirm Account Number</mat-label>
                      <input readonly="readonly"  matInput  placeholder="Confirm Account Number"
                             >
                    </mat-form-field>
                  </div>
                </div>
                <div class="row" style="justify-content: space-between;">
                  <div class="column">
                    <p>
                    <label> Account Type </label> 
                      <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
                        <mat-button-toggle value="1">Chenking</mat-button-toggle>
                        <mat-button-toggle value="2">Savings</mat-button-toggle>
                      </mat-button-toggle-group>
                    </p>
                  </div>
                  <div class="column" style="justify-content: end;">
                    <p>
                    <label> Account Is </label> 
                      <mat-button-toggle-group  name="fontStyle" aria-label="Font Style">
                        <mat-button-toggle value="1">Business</mat-button-toggle>
                        <mat-button-toggle value="2">Personal</mat-button-toggle>
                      </mat-button-toggle-group>
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="column">
                    <mat-form-field appearance="outline" >
                      <mat-label>Billing Street <Address></Address></mat-label>
                      <input readonly="readonly"  matInput placeholder="Billing Street"
                             >
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="column">
                    <mat-form-field appearance="outline" >
                      <mat-label>Apt/Unit/Suite</mat-label>
                      <input readonly="readonly"  matInput placeholder="Apt/Unit/Suite"
                             >
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="column">
                    <mat-form-field appearance="outline" >
                      <mat-label>City</mat-label>
                      <input readonly="readonly"  matInput  placeholder="City"
                             >
                    </mat-form-field>
                  </div>
            
                  <div class="column">
                    <mat-form-field appearance="outline" >
                      <mat-label>State</mat-label>
                      <input readonly="readonly"  matInput  placeholder="State"
                             >
                    </mat-form-field>
                  </div>
            
                  <div class="column">
                    <mat-form-field appearance="outline" >
                      <mat-label>Zip Code</mat-label>
                      <input readonly="readonly"  matInput  placeholder="Zip Code"
                             >
                    </mat-form-field>
                  </div>
            
            
                  <div class="column">
                    <mat-form-field appearance="outline" >
                      <mat-label>Country</mat-label>
                      <input matInput  placeholder="Country"
                             >
                    </mat-form-field>
                  </div>
                </div>
            
                <div class="row">
                  <div class="column">
                    <mat-form-field appearance="outline" >
                      <mat-label>Email Address</mat-label>
                      <input matInput  placeholder="Email Address"
                             >
                    </mat-form-field>
                  </div>
                  <div class="column">
                    <mat-form-field appearance="outline" >
                      <mat-label>Phone Number</mat-label>
                      <input matInput  placeholder="Phone Number"
                             >
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                    
                  <div class="column">
                   
                    <section class="example-section">
                        <label class="example-margin"> Receipt By :</label>  
                      <mat-checkbox  color="primary" class="example-margin" >Email</mat-checkbox>
                      <mat-checkbox  color="primary" class="example-margin">Text</mat-checkbox>
                    </section>
                  </div>
                </div>
                <div class="row">
            <div class="column">
            
              <mat-form-field appearance="outline" >
                <mat-label>Memo</mat-label>
                <textarea matInput placeholder="Memo"></textarea>
              </mat-form-field>
            
            </div>
                </div>
                </form>
                
            
      </mat-card-content>
    <mat-card-actions style="justify-content: space-between;">
        <button mat-flat-button color="primary">Save</button>
        <button mat-flat-button color="warn" >Cancel</button>
    </mat-card-actions>
  </mat-card>
</div>
